import { SxProps, Theme } from '@mui/material';
import { alpha } from '@mui/material/styles';

export const filterFormSx: SxProps<Theme> = {
  display: 'flex',
  flexDirection: 'column',
  gap: '12px',
  width: '100%',
  '& [data-filter-section], & [data-filter-group]': {
    minWidth: 0,
    p: 2,
    bgcolor: 'common.white',
    borderRadius: '16px',
    boxShadow: '0 4px 14px rgb(0 0 0 / 7%)',
  },
  '& [data-filter-group]': {
    display: 'flex',
    flexDirection: 'column',
    gap: 2,
  },
  '& [data-filter-group] [data-filter-section]': {
    p: 0,
    borderRadius: 0,
    boxShadow: 'none',
  },
  '& [data-filter-section] > .MuiDivider-root': { display: 'none' },
  '& [data-filter-section] .MuiFormControl-root': { m: 0, width: '100%', minWidth: 0 },
  '& [data-filter-label], & [data-filter-section] .MuiFormLabel-root': {
    display: 'block',
    mb: 1,
    color: 'text.secondary',
    fontSize: 12,
    fontWeight: 700,
    lineHeight: '16px',
    letterSpacing: '0.5px',
    textTransform: 'uppercase',
  },
  '& [data-filter-section] .MuiFormGroup-root': { m: 0, gap: 1 },
  '& [data-filter-section] .MuiChip-root': {
    m: '0 !important',
    maxWidth: '100%',
    height: 'auto',
    minHeight: 32,
    fontSize: 12,
    fontWeight: 500,
    color: 'text.primary',
    '& .MuiChip-label': { px: '14px', py: '6px', whiteSpace: 'normal' },
    '&.MuiChip-colorPrimary': {
      minHeight: 28,
      fontSize: 14,
      fontWeight: 400,
      '& .MuiChip-label': { px: 1, py: '4px', overflow: 'visible' },
      '& .MuiChip-deleteIcon': {
        flexShrink: 0,
        width: 18,
        height: 18,
        ml: '-4px',
        mr: '4px',
        color: 'rgba(255, 255, 255, 0.7)',
      },
    },
  },
  '& [data-filter-section="dateRangePicker"] .MuiChip-root': {
    '&.MuiChip-colorPrimary': { bgcolor: 'primary.main' },
    '&.Mui-disabled': {
      opacity: 1,
      bgcolor: (theme) => alpha(theme.palette.primary.main, 0.14),
    },
  },
  '& [data-filter-section="dateRangePicker"] .MuiFormGroup-root': {
    alignItems: 'flex-start',
  },
  '& [data-filter-section] .MuiFormControlLabel-root': { m: 0, gap: '12px' },
  '& [data-filter-section] .MuiFormControlLabel-label': { fontSize: 16, fontWeight: 500 },
  '& [data-filter-section] .MuiSwitch-root': {
    width: 44,
    height: 24,
    p: 0,
    overflow: 'visible',
    flexShrink: 0,
    '& .MuiSwitch-switchBase': {
      p: '2px',
      '&.Mui-checked': { transform: 'translateX(20px)', color: 'common.white' },
      '&.Mui-focusVisible .MuiSwitch-thumb': {
        outline: '2px solid',
        outlineColor: 'primary.main',
        outlineOffset: 2,
      },
    },
    '& .MuiSwitch-thumb': { width: 20, height: 20 },
    '& .MuiSwitch-track': { borderRadius: '12px', bgcolor: 'grey.300', opacity: 1 },
    '& .Mui-checked + .MuiSwitch-track': { bgcolor: 'primary.main', opacity: 1 },
  },
};
